import { CssBaseline, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import '@/setup/sentry';
import '@/setup/api';
import '@/setup/i18n';
import '@/setup/dayjs';
import { App } from '@/App';
import { AbilityProvider } from '@/components/casl/AbilityProvider';
import { queryClient } from '@/setup/query-client';
import { theme } from '@/setup/theme';

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AbilityProvider>
          <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
              <CssBaseline />
              <App />
            </LocalizationProvider>
          </ThemeProvider>
        </AbilityProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
